var heading4G = {
  "fontFamily": "Guardian, \"Helvetica Neue\", Helvetica, sans-serif",
  "fontWeight": "400",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem"
};

export { heading4G };
